<template>
    <v-textarea
        append-inner-icon="mdi-clipboard"
        rows="1"
        readonly
        style="width: 400px;"
        label="Строка подключения"
        variant="outlined"
        auto-grow
        :model-value="payload.value"
        @click:appendInner="copyToClipboard">
    </v-textarea>
</template>

<script>
export default {
    name: 'WebDAV',
    props: {
        payload: Object,
    },
    methods: {
        copyToClipboard() {
            navigator.clipboard?.writeText(this.payload.value);
        },
    },
};
</script>

<style>

</style>
